import { Alignment, BoxModelConstraint, CellPanel, CellRenderer, RowPanel, StaticParagraphComponent } from '@blk/simba';
import { CellData } from '@ddt-web/data-service';

import { IconRenderer } from './icon-renderer';

export class IconAndTextRenderer implements CellRenderer {
	constructor(
		private cell: CellData,
		private iconWidth: number,
		private iconHeight: number,
		private hAlign: Alignment.Horizontal,
		private widthProportion: number,
		private childrenProportions: Array<number>,
		private textClasses?: Array<string>,
		private constraints?: Partial<BoxModelConstraint>,
		private iconType?: string,
		private vAlignRow = Alignment.Vertical.Bottom
	) {
		if (!childrenProportions || childrenProportions.length !== 2) {
			throw new Error(`IconAndTextRenderer : Width proportions are either not defined or are not correct.`);
		}
	}

	public render(): CellPanel {
		const text = this.cell && this.cell.formattedValue;

		return new CellPanel(
			[
				new RowPanel(
					'Icon And Text Row',
					[
						new CellPanel(
							[new IconRenderer(this.cell.attribute.iconType || this.iconType, this.iconHeight, this.iconWidth, this.cell.attribute.colorTheme || '#000')],
							{ proportion: this.childrenProportions[0] },
							this.hAlign
						),
						new CellPanel(
							[new StaticParagraphComponent(null, text === undefined ? '-' : text, {}, BoxModelConstraint.merge(this.constraints), this.textClasses)],
							{ proportion: this.childrenProportions[1] },
							this.hAlign
						)
					],
					BoxModelConstraint.merge(this.constraints),
					Alignment.Horizontal.Left,
					this.vAlignRow
				)
			],
			{ proportion: this.widthProportion },
			this.hAlign
		);
	}
}
